import { useEffect, useState } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { Alert, Container, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getObjectiveHistory } from "../../redux/evaluacion_desempenio/ObjectiveHistory/actions";
import moment from "moment";



const ObjectiveChangeHistory = (props) => {
    const [show, setShow] = useState(false);
    const onShowSidebar = () => setShow(show ? false : true);
    const dispatch = useDispatch();
    const { idEvaluacion } = useParams()

    const {
        objectiveHistories,
        objectiveHistoriesLength,
        loading,
        objectiveHistoryError
    } = useSelector((state) => state.objectiveHistory);


    useEffect(() => {
        dispatch(getObjectiveHistory({
            evaluacion_empleado: parseInt(idEvaluacion)
        }));
    }, [])

    // Función para comparar con la versión anterior
    const getDiffClass = (current, previous, field) => {
        if (!previous) return "#D8FCD1"; // Si no hay versión anterior, es nuevo
        return current[field] !== previous[field] ? "#FEED9A" : "";
    };

    const handleBack = () => {
        props.history.goBack();
    }

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <h3><i className="material-icons mr-3" style={{ cursor: "pointer" }} onClick={handleBack}>arrow_back</i> Historial de Cambios</h3>
                    <p>Aquí puedes ver el historial de cambios en los objetivos.</p>
                    
                    <hr />

                    <div className="p-3 mb-4">
                        <h5 className="mb-2" >LEYENDA</h5>
                        <p>El color de cada celda tiene los siguientes significados:</p>
                        <p><span className="border p-2 mr-2" style={{ backgroundColor: "#D8FCD1" }}>Nuevo</span> <span className="border p-2 mr-2" style={{ backgroundColor: "#FEED9A" }}>Modificado</span></p>
                    </div>

                    <Alert show={objectiveHistoriesLength === 0 && !loading} variant="info">
                        No han habido cambios en los objetivos.
                    </Alert>
                    <Alert show={objectiveHistoryError} variant="danger">
                        {objectiveHistoryError}
                    </Alert>

                    {loading ?
                        (
                            <div className="text-center my-4">
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    className="mr-2"
                                />
                            </div>

                        )
                        : objectiveHistories?.map((history, historyIndex) => (
                            <div className="mb-4 p-3 border rounded" key={history.id}>
                                <h5>Fecha: {moment(history.fecha_creacion).format("DD/MM/YYYY HH:mm:ss")}</h5>
                                <p className="mb-3"><strong>Creado por: </strong>{history.nombre_usuario_data}</p>

                                <Table striped bordered hover responsive size="sm">
                                    <thead>
                                        <tr>
                                            <th className="border p-2">Pilar Estratégico</th>
                                            <th className="border p-2">Nombre</th>
                                            <th className="border p-2">Peso</th>
                                            <th className="border p-2">Indicador</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {history.cambios.objetivos.map((obj, i) => {
                                            const prevObj = objectiveHistories[historyIndex - 1]?.cambios.objetivos.find(
                                                (o) => o.id === obj.id
                                            );
                                            return (
                                                <tr key={i}>
                                                    <td className={`border p-2`} style={{ backgroundColor: getDiffClass(obj, prevObj, "pilar_estrategico_nombre") }}>
                                                        {obj.pilar_estrategico_nombre}
                                                    </td>
                                                    <td className={`border p-2`} style={{ backgroundColor: getDiffClass(obj, prevObj, "nombre") }}>
                                                        {obj.nombre}
                                                    </td>
                                                    <td className={`border p-2`} style={{ backgroundColor: getDiffClass(obj, prevObj, "peso") }}>
                                                        {obj.peso}
                                                    </td>
                                                    <td className={`border p-2`} style={{ backgroundColor: getDiffClass(obj, prevObj, "indicador") }}>
                                                        {obj.indicador}
                                                    </td>

                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </Table>
                            </div>
                        ))}



                </Container>
            </div>
        </>
    )
}

export default ObjectiveChangeHistory